import React from 'react';
import { Input } from 'antd';
import ErrorTag from './ErrorTag';
import { StyledError, StyledLabel } from './Field.styled';

const FieldInput = ({
    input,
    custom,
    label,
    parent,
    type,
    textarea,
    meta: { touched, error, warning },
}) => {
    const parentProps = parent || {};

    return (
        <div {...parentProps} className={`${parentProps.className} ${touched && error ? 'has-error' : ''}`}>
            { label && <StyledLabel>{label}</StyledLabel>}

            { textarea ? <Input.TextArea {...input} {...custom} /> : <Input {...input} {...custom} type={type} /> }

            { touched && (
                (error && <ErrorTag id={error} params={custom.params} />)
                || (warning && <StyledError>{warning}</StyledError>))
            }
        </div>
    );
};

export default FieldInput;
